import { authHeader } from '../_helpers';

export const adminService = {
    getUsers,
    updateUser,
    getAccounts,
    getScorecards
};

function getUsers() {
    return fetch(process.env.VUE_APP_API_URL + "/api/v1/admin/users", {
        method: 'GET',
        headers: authHeader()
    })
        .then(handleResponse)
        .then(data => data.users || []);
}

function updateUser(user_id, payload) {
    return fetch(process.env.VUE_APP_API_URL + "/api/v1/admin/users/" + user_id, {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(payload)
    })
        .then(handleResponse)
        .then(data => data.user || null);
}

function getAccounts() {
    return fetch(process.env.VUE_APP_API_URL + "/api/v1/admin/accounts", {
        method: 'GET',
        headers: authHeader()
    })
        .then(handleResponse)
        .then(data => data.accounts || []);
}

function getScorecards() {
    return fetch(process.env.VUE_APP_API_URL + "/api/v1/admin/scorecards", {
        method: 'GET',
        headers: authHeader()
    })
        .then(handleResponse)
        .then(data => data.scorecards || []);
}

function handleResponse(response) {
    return response.text()
        .then(text => {
            var data = text && JSON.parse(text);
            if (!response.ok) {
                const error = (data && data.message) || response.statusText;
                return Promise.reject(error);
            }
            return data;
        });
}
